import CommonDelete from "@/components/common/Delete";
import { singleProp } from "@/interface/dataInterface";
import { FC } from "react";

const ServiceDelete: FC<singleProp> = ({prop}) => (
    <CommonDelete id={prop} resource="auto-service" />
)

export default ServiceDelete